import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetQuestionListLoading, EGetQuestionListActionType } from './types';

export const getQuestionListLoading: () => TGetQuestionListLoading =
  actionGenerator<EGetQuestionListActionType.Loading>(EGetQuestionListActionType.Loading);
